import "./pagination.scss"

import React from "react"

const Pagination = ({
  currentPage = 1,
  numPages = 1,
  onPrevClick,
  onNextClick,
  onItemClick,
}) => {
  const isBrowser = typeof window !== "undefined"
  const isFirst = currentPage === 1
  const isLast = currentPage === numPages

  const current = Number(currentPage)

  return (
    <div className="pagination">
      {!isFirst && (
        <button
          onClick={onPrevClick}
          className="pagination__arrows pagination__arrows--prev"
        >
          Prev
        </button>
      )}
      {Array.from({ length: numPages }, (_, i) => (
        <button
          key={`pagination-number${i + 1}`}
          onClick={isBrowser && onItemClick.bind(null, i + 1)}
          className={`pagination__item${
            i === current - 1 ? " pagination__current" : " pagination__last"
          }`}
          aria-hidden="true"
        >
          {i + 1}
        </button>
      ))}
      {!isLast && (
        <button
          onClick={onNextClick}
          className="pagination__arrows pagination__arrows--next"
        >
          Next
        </button>
      )}
    </div>
  )
}

export default Pagination
